(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hale-ridge-pdp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hale-ridge-pdp')) {
  class HaleRidgePDP extends HTMLElement {
    connectedCallback() {
      this.bundleCards = Array.from(this.querySelectorAll('[data-bundle]'));
      this.primaryBundleCards = Array.from(this.querySelectorAll('.hr-pdp__bundle-card[data-bundle]'));
      this.atcLinks = Array.from(this.querySelectorAll('[data-hr-atc]'));
      this.stickyLabel = this.querySelector('[data-sticky-label]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.selectedPrice = this.querySelector('[data-selected-price]');
      this.selectedSavings = this.querySelector('[data-selected-savings]');
      this.selectedShipping = this.querySelector('[data-selected-shipping]');
      this.bundleSelector = this.querySelector('.hr-pdp__bundle-zone');
      this.primaryAtc = this.querySelector('.hr-pdp__atc');
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.dialog = this.querySelector('[data-lightbox-dialog]');
      this.dialogImage = this.querySelector('[data-lightbox-image]');
      this.galleryTrack = this.querySelector('[data-gallery-track]');
      this.gallerySlides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.galleryDots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.currentSlide = 0;
      this.scrollMilestones = new Set();
      this.attributionKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid','msclkid'];
      this.captureAttribution();
      this.bindBundles();
      this.bindGallery();
      this.bindLightbox();
      this.bindFaq();
      this.bindFinalCta();
      this.bindCheckoutTracking();
      this.bindScrollTracking();
      this.bindSticky();
      const storedBundle = window.sessionStorage.getItem('hale_ridge_bundle');
      const initialBundle = ['1','2','3'].includes(storedBundle) ? storedBundle : '2';
      this.setBundle(initialBundle, false);
      this.track('hale_ridge_pdp_view', { product_id: this.dataset.productId || '', variant_id: this.dataset.variantId || '' });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScrollBound);
      document.removeEventListener('click', this.handleCheckoutBound);
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    track(name, detail = {}) {
      const payload = { event: name, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      this.dispatchEvent(new CustomEvent('hale-ridge:track', { bubbles: true, detail: payload }));
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, detail);
    }

    captureAttribution() {
      const current = new URLSearchParams(window.location.search);
      const saved = {};
      this.attributionKeys.forEach((key) => {
        if (current.has(key)) saved[key] = current.get(key);
      });
      if (Object.keys(saved).length) window.sessionStorage.setItem('hale_ridge_attribution', JSON.stringify(saved));
    }

    getAttribution() {
      const current = new URLSearchParams(window.location.search);
      const result = {};
      this.attributionKeys.forEach((key) => {
        if (current.has(key)) result[key] = current.get(key);
      });
      if (!Object.keys(result).length) {
        try { return JSON.parse(window.sessionStorage.getItem('hale_ridge_attribution') || '{}'); } catch (error) { return {}; }
      }
      return result;
    }

    withAttribution(baseUrl) {
      const url = new URL(baseUrl, window.location.origin);
      const attribution = this.getAttribution();
      Object.entries(attribution).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); });
      return url.toString();
    }

    bundleData(quantity) {
      const card = this.primaryBundleCards.find((item) => item.dataset.bundle === String(quantity));
      if (!card) return null;
      return {
        quantity: String(quantity),
        label: card.dataset.bundleLabel || '',
        price: card.dataset.price || '',
        shipping: card.dataset.shipping || '',
        savings: card.dataset.savings || '',
        cartUrl: card.dataset.cartUrl || ''
      };
    }

    setBundle(quantity, shouldTrack = true) {
      const selected = this.bundleData(quantity);
      if (!selected) return;
      window.sessionStorage.setItem('hale_ridge_bundle', selected.quantity);
      this.bundleCards.forEach((card) => {
        const isSelected = card.dataset.bundle === selected.quantity;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        const state = card.querySelector('[data-bundle-state]');
        if (state) state.textContent = isSelected ? (card.dataset.selectedLabel || '') : (card.dataset.selectLabel || '');
      });
      const attributedUrl = this.withAttribution(selected.cartUrl);
      this.atcLinks.forEach((link) => { link.href = attributedUrl; link.dataset.bundle = selected.quantity; });
      if (this.stickyLabel) this.stickyLabel.textContent = selected.label;
      if (this.stickyPrice) this.stickyPrice.textContent = selected.price;
      if (this.selectedPrice) this.selectedPrice.textContent = selected.price;
      if (this.selectedSavings) { this.selectedSavings.textContent = selected.savings; this.selectedSavings.hidden = !selected.savings; }
      if (this.selectedShipping) this.selectedShipping.textContent = selected.shipping;
      if (shouldTrack) this.track(`hale_ridge_bundle_${selected.quantity}_selected`, { quantity: Number(selected.quantity), price: selected.price, shipping: selected.shipping, savings: selected.savings });
    }

    bindBundles() {
      this.bundleCards.forEach((card) => card.addEventListener('click', () => this.setBundle(card.dataset.bundle, true)));
      this.atcLinks.forEach((link) => link.addEventListener('click', () => {
        const selected = this.bundleData(link.dataset.bundle || '2');
        this.track('hale_ridge_add_to_cart', selected || {});
      }));
    }

    bindGallery() {
      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const go = (index) => {
        if (!this.gallerySlides.length) return;
        this.currentSlide = (index + this.gallerySlides.length) % this.gallerySlides.length;
        this.galleryTrack?.scrollTo({ left: this.gallerySlides[this.currentSlide].offsetLeft, behavior: 'smooth' });
        this.galleryDots.forEach((dot, i) => {
          const active = i === this.currentSlide;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };
      if (prev) prev.addEventListener('click', () => go(this.currentSlide - 1));
      if (next) next.addEventListener('click', () => go(this.currentSlide + 1));
      this.galleryDots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.galleryDot))));
      if (this.galleryTrack) {
        let ticking = false;
        this.galleryTrack.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            const width = this.galleryTrack.clientWidth || 1;
            const index = Math.round(this.galleryTrack.scrollLeft / width);
            this.currentSlide = Math.max(0, Math.min(index, this.gallerySlides.length - 1));
            this.galleryDots.forEach((dot, i) => {
              const active = i === this.currentSlide;
              dot.classList.toggle('is-active', active);
              dot.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            ticking = false;
          });
        }, { passive: true });
      }
    }

    bindLightbox() {
      this.querySelectorAll('[data-lightbox]').forEach((button) => button.addEventListener('click', () => {
        if (!this.dialog || !this.dialogImage) return;
        this.dialogImage.src = button.dataset.lightboxSrc || '';
        this.dialogImage.alt = button.dataset.lightboxAlt || '';
        if (button.dataset.interaction === 'coa') this.track('hale_ridge_coa_interaction');
        if (button.dataset.interaction === 'before_after') this.track('hale_ridge_before_after_interaction');
        this.dialog.showModal();
      }));
      const close = this.querySelector('[data-lightbox-close]');
      if (close && this.dialog) close.addEventListener('click', () => this.dialog.close());
      if (this.dialog) this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
    }

    bindFaq() {
      this.querySelectorAll('[data-faq]').forEach((item, index) => item.addEventListener('toggle', () => {
        if (item.open) this.track('hale_ridge_faq_expansion', { faq_index: index + 1, question: item.querySelector('summary')?.textContent?.trim() || '' });
      }));
    }

    bindFinalCta() {
      const finalCta = this.querySelector('[data-final-cta]');
      if (!finalCta) return;
      finalCta.addEventListener('click', () => {
        this.track('hale_ridge_final_cta_click');
        this.bundleSelector?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    bindSticky() {
      if (!this.primaryAtc || !this.stickyBar || !('IntersectionObserver' in window)) return;
      this.stickyBar.hidden = false;
      this.stickyObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const passedPrimaryCta = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.stickyBar.classList.toggle('is-visible', passedPrimaryCta);
      }, { threshold: 0.05 });
      this.stickyObserver.observe(this.primaryAtc);
    }

    bindCheckoutTracking() {
      this.handleCheckoutBound = (event) => {
        const target = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
        if (target) this.track('hale_ridge_checkout_initiation');
      };
      document.addEventListener('click', this.handleCheckoutBound);
    }

    bindScrollTracking() {
      this.handleScrollBound = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const height = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
        const percent = (scrollTop / height) * 100;
        [25, 50, 75, 90].forEach((milestone) => {
          if (percent >= milestone && !this.scrollMilestones.has(milestone)) {
            this.scrollMilestones.add(milestone);
            this.track('hale_ridge_pdp_scroll', { percent: milestone });
          }
        });
      };
      window.addEventListener('scroll', this.handleScrollBound, { passive: true });
      this.handleScrollBound();
    }
  }
  customElements.define('hale-ridge-pdp', HaleRidgePDP);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tendford-product-page"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tendford-pdp')) {
  customElements.define('tendford-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.classList.add('tf-ready');
      const slides = this.querySelector('.tf-slides');
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      let index = 0;
      const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const move = n => { index = (n + thumbs.length) % thumbs.length; slides.scrollTo({left: index * slides.clientWidth, behavior: motion}); };
      const update = () => {
        index = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        thumbs.forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
        this.querySelector('[data-count]').textContent = `${index + 1} / ${thumbs.length}`;
      };
      slides.addEventListener('scroll', update, {signal, passive:true});
      slides.addEventListener('keydown', e => {if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){e.preventDefault();move(index + (e.key === 'ArrowRight' ? 1 : -1));}}, {signal});
      thumbs.forEach((button,n) => button.addEventListener('click',()=>move(n),{signal}));
      this.querySelector('[data-prev]').addEventListener('click',()=>move(index-1),{signal});
      this.querySelector('[data-next]').addEventListener('click',()=>move(index+1),{signal});
      this.resize = new ResizeObserver(()=>{slides.scrollTo({left:index*slides.clientWidth,behavior:'instant'});});
      this.resize.observe(slides);
      this.querySelectorAll('input[type=radio]').forEach(input=>input.addEventListener('change',()=>{
        this.querySelectorAll('[data-buy]').forEach(link=>link.href=link.dataset.base+input.value);
        this.querySelectorAll('[data-price]').forEach(el=>{if(el.tagName !== 'INPUT')el.textContent=input.dataset.price;});
      },{signal}));
      const dialog = this.querySelector('dialog');
      this.querySelector('[data-zoom]').addEventListener('click',()=>{
        const source=slides.children[index].querySelector('img');
        const target=dialog.querySelector('img');target.src=source.src;target.alt=source.alt;
        dialog.showModal();
      },{signal});
      dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close(),{signal});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();},{signal});
      const sticky=this.querySelector('.tf-sticky');
      if(sticky){this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top>0;},{threshold:0});this.observer.observe(this.querySelector('.tf-main-buy'));}
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();this.observer?.disconnect();}
  });
}


  } catch(e) { console.error(e); }
})();
})();
